/// <amd-module name="typeahead/features/AtlasHigherLevelRegionsParamModifier" />
/// <amd-dependency path="jquery" name="$"/>

/// <reference path="../../typings/typeahead/browser.d.ts" />
/// <reference path="../../typings/typeahead/ExpediaSuggestServiceRequestGenerator.d.ts" />

import {IStripingConfiguration} from "typeahead/core/StripingConfiguration";
import {SuggestServiceParamModifier} from "typeahead/core/SuggestServiceParamModifier";

export class AtlasHigherLevelRegionsParamModifier extends SuggestServiceParamModifier {
    protected configuration: IStripingConfiguration[] = [{
        lobs: ["HOTELS"],
    }];
    protected featureName: string = "IncludeHLR";

    protected modify(params: ISuggestServiceQueryParams, context: IContext, options: any) {
        this.addRegionType(params, 256);
    }
}
